export const LIST_SIZES = {
  LARGE: 'large',
  STANDARD: 'standard',
};

export const LIST_ITEM_DIVIDER_TYPES = {
  FULL: 'full',
  INSET: 'inset',
};
